import { render, staticRenderFns } from "./default2022.vue?vue&type=template&id=499b3cb4&"
import script from "./default2022.vue?vue&type=script&lang=ts&"
export * from "./default2022.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports